import * as React from 'react';
export const SZSvg = React.forwardRef(function SZSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement(
      'g',
      {
        fill: 'none',
        fillRule: 'evenodd',
      },
      /*#__PURE__*/ React.createElement('path', {
        fill: '#555ABF',
        d: 'M1 2h14c.555 0 1 .448 1 1v1H0V3c0-.556.448-1 1-1ZM0 12h16v1c0 .556-.448 1-1 1H1c-.555 0-1-.448-1-1v-1Z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#FCD669',
        d: 'M0 4h16v8H0z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#A68527',
        fillOpacity: 0.1,
        fillRule: 'nonzero',
        d: 'M15 12V4h1v8h-1ZM0 4h1v8H0V4Z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#B1372F',
        d: 'M0 5h16v6H0z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#333',
        d: 'M8 10V6c-2.08 0-4 .895-4 2s1.79 2 4 2Z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#F6F9FC',
        d: 'M8 10V6c2.08 0 4 .895 4 2s-1.79 2-4 2Z',
      }),
    ),
  );
});
SZSvg.defaultProps = {
  xmlns: 'http://www.w3.org/2000/svg',
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
};
export var SZ = {
  category: 'flag',
  colorable: false,
  name: 'SZ',
  svg: SZSvg,
};
